import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { authService } from "api/axios";
import { APP_CLIENT_ID, APP_CLIENT_SECRET } from "context/AuthContext";
import styles from "assets/jss/material-dashboard-pro-react/views/resetPasswordPageStyle";

const useStyles = makeStyles(styles);

const RESET_PASSWORD_URL = '/api/resetPassword';
const GET_CLIENT_TOKEN_URL = '/api/getClientToken?client_id=';


export default function ResetPasswordPage() {
    const history = useHistory();
    const [clientToken, setClientToken] = useState("");
    const [formData, setFormData] = useState({ email: "", newPassword: "", code: "" });
    const [successMsg, setSuccessMsg] = useState("");
    const [errMsg, setErrMsg] = useState("");


    // Fetch client token on component mount
    useEffect(() => {
        const controller = new AbortController();

        const getClientToken = async () => {
            try {
                const credentials = btoa(`${APP_CLIENT_ID}:${APP_CLIENT_SECRET}`);
                const response = await authService.get(GET_CLIENT_TOKEN_URL + "8", {
                    headers: {
                        Authorization: `Basic ${credentials}`,
                    },
                });
                setClientToken(response.data.token);
            } catch (error) {
                console.error("Error fetching client token", error);
            }
        };

        getClientToken();

        return () => {
            controller.abort();
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        try {
            const payload = {
                password: formData.newPassword,
                userName: formData.email,
                code: formData.code,
            };

            const response = await authService.post(RESET_PASSWORD_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${clientToken}`,
                },
            });

            setSuccessMsg(response.data.message);
            setTimeout(() => history.push("/login"), 3000);
        } catch (error) {
            console.error("Reset Password Error", error);
            if (!error?.response) {
                setErrMsg("No Server Response");
            } else if (error.response?.status === 400) {
                setErrMsg("Invalid request. Check your inputs.");
            } else if (error.response?.status === 401) {
                setErrMsg("Unauthorized. Please try again.");
            } else if (error.response?.status === 404) {
                setErrMsg("Invalid code or email. Please check and try again.");
            } else {
                setErrMsg("Reset Failed. Please try again later.");
            }
        }
    };

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={6} md={4}>
                    <Card>
                        <CardHeader color="primary" className={classes.cardHeader}>
                            <h4>Reset Password</h4>
                        </CardHeader>
                        <CardBody>
                            {successMsg && <p style={{ color: "green" }}>{successMsg}</p>}
                            {errMsg && <p style={{ color: "red" }}>{errMsg}</p>}
                            <CustomInput
                                labelText="Email..."
                                formControlProps={{ fullWidth: true }}
                                inputProps={{
                                    name: "email",
                                    value: formData.email,
                                    onChange: handleChange,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Email />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <CustomInput
                                labelText="New Password..."
                                formControlProps={{ fullWidth: true }}
                                inputProps={{
                                    name: "newPassword",
                                    type: "password",
                                    value: formData.newPassword,
                                    onChange: handleChange,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Icon>lock</Icon>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <CustomInput
                                labelText="Code..."
                                formControlProps={{ fullWidth: true }}
                                inputProps={{
                                    name: "code",
                                    value: formData.code,
                                    onChange: handleChange,
                                }}
                            />
                            <Button color="primary" fullWidth onClick={handleSubmit}>
                                Submit
                            </Button>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
